import React, { Component } from "react";
import { List, Segment } from "semantic-ui-react";
import moment from "moment";

class Details extends Component {
  constructor(props) {
    super(props);
    let orders = this.props.orders;

    this.state = {
      orders : orders,
      isLoading: false,
      xhrResponse: {
        success: null,
        message: ""
      }
    };
  }
  

  render() {
    const {
      orders,
      isLoading
    } = this.props;

    return (
        <Segment basic loading={isLoading}>
        <List>
          {orders.map((value, index) => (
            <List.Item key={index}>{moment.unix(value.dateline).format("YYYY-MM-DD HH:mm")}</List.Item>
          ))}
        </List>
      </Segment>
    );
  }
}

export default Details;
